import React from "react";
import { PromoCareProduct, OrderPromoCareItem } from "@/features/facility/orders/types";

type ProductListProps = {
  products: PromoCareProduct[];
  orderItems?: OrderPromoCareItem[];
  setOrderItems?: React.Dispatch<React.SetStateAction<OrderPromoCareItem[]>>;
  title: string;
}

const ProductList: React.FC<ProductListProps> = ({ products, orderItems, setOrderItems, title }) => {
  return (
    <>
      <h2 className="c-ttl__02">{title}</h2>
      <div className="table-scroll">
        <div className="table-scroll__main">
          <ul className="contact-box__th contact-box__list">
            {["商品コード", "品名", "発注単位", "数量"].map((name) => (
              <li key={name} className="contact-box__list-item">{name}</li>
            ))}
          </ul>
          {products.map((product: PromoCareProduct) => {
            const orderItem = (orderItems && orderItems.find((item: OrderPromoCareItem) => item.productId === product.id)) || undefined;
            return (
            <ul className="contact-box__td contact-box__list" key={product.itemCode}>
              <li className="contact-box__list-item">{product.itemCode}</li>
              <li className="contact-box__list-item">{product.name}</li>
              <li className="contact-box__list-item">{product.orderingUnitLabel}</li>
              <li className="contact-box__list-item">
                  {setOrderItems ?
                    <>
                      <div className="select-custom">
                        <select
                          value={orderItem?.qty}
                          onChange={(e) => {
                            const newQty = e.target.value;
                            setOrderItems(prevItems => {
                              const currentItems = prevItems || [];
                              if (newQty !== "") {
                                const newItem = {
                                  productId: product.id,
                                  qty: parseInt(newQty, 10),
                                  quantityUnit: product.quantityUnit,
                                };
                                const itemIndex = currentItems.findIndex(item => item.productId === product.id);
                                if (itemIndex !== -1) {
                                  return [
                                    ...currentItems.slice(0, itemIndex),
                                    newItem,
                                    ...currentItems.slice(itemIndex + 1)
                                  ];
                                } else {
                                  return [...currentItems, newItem];
                                }
                              } else {
                                return currentItems.filter(item => item.productId !== product.id);
                              }
                            });
                          }}
                        >
                          <option value=""></option>
                          {[...Array(Math.floor((product.qtyMax - product.qtyMin) / product.orderingUnit) + 1).keys()].map((i) => {
                            const qty = product.qtyMin + i * product.orderingUnit;
                            return <option key={qty} value={qty}>{qty}</option>;
                          })}
                        </select>
                      </div>
                      <small>{product.quantityUnit}</small>
                    </>
                  :
                    <>
                      {orderItem?.qty}
                      {product.quantityUnit}
                    </>
                  }
              </li>
            </ul>
            )
          })}
        </div>
      </div>
    </>
  );
};

export default ProductList;